import React from "react";

export function TextBox({ className,p1,p2,p3 }) {

  const paragraphs = [p1, p2, p3];

  return (
    <>

      {paragraphs.map((text, index) => (
        <p key={index} className={className}>
          {text}
        </p>
      ))}

    </>
  );
}